import React, { useEffect } from 'react';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { EVENTS } from '~/jobiqo/lib/analytics';
import { logAnalyticsServerEvent } from '~/jobiqo/services/analytics';

interface ServerSideTrackingProps {
  /**
   * The current processed path to track page views.
   */
  processedPath: string;

  /**
   * Whether we're in testing mode.
   */
  testing: boolean;

  /**
   * Whether we're in development mode.
   */
  development: boolean;
}

/**
 * Component dedicated to server-side tracking events only.
 * This handles page view tracking specifically for server-side analytics (SST),
 * separate from client-side analytics like Google Analytics
 * to avoid duplicate events.
 */
const ServerSideTracking: React.FC<ServerSideTrackingProps> = ({
  processedPath,
  testing,
  development,
}) => {
  const { APP } = useFrontendConfig();
  // Log every page view based on change of processedPath value.
  useEffect(() => {
    if (!testing && !development && APP.GOOGLE_MEASUREMENT_API_ENABLED) {
      logAnalyticsServerEvent(EVENTS.PAGE_VIEW);
    }
  }, [processedPath, testing, development, APP.GOOGLE_MEASUREMENT_API_ENABLED]);

  return null;
};

export default ServerSideTracking;
